import React from 'react';
import styled from 'styled-components/macro';
import { Modal } from 'lib/components';
import { Button } from 'react-covideo-common';
import { useTranslation } from 'react-i18next';
import { useCDK } from 'lib/hooks/useCdk';
import { useAuth } from 'lib/context';

const Header = styled.div`
  display: flex;
`;

const HeaderTitle = styled.div`
  font-weight: 700;
  font-size: 18px;
  color: ${({ theme }) => theme.colors.black[100]};
`;

const Content = styled.div`
  width: 800px;
  display: flex;
  flex-direction: column;
  margin-top: 40px;
  align-items: start;
`;

const Footer = styled.div`
  margin-top: 32px;
  display: flex;
  justify-content: flex-end;
  > button {
    margin-left: 12px;
  }
`;

type Props = {
  handleModalClose: () => void;
  style?: React.CSSProperties;
};

export const LoginAsModal = (props: Props) => {
  const { t } = useTranslation();
  const { logoutUser } = useAuth();
  const { isCdkUser } = useCDK();
  const [windowHandler, setWindowHandler] = React.useState<Window | null>(null);

  const { handleModalClose, style } = props;

  React.useEffect(() => {
    const path = isCdkUser ? '/admin' : '/';
    const newPage = window.open(path, '_crosslogin');
    setWindowHandler(newPage);
    const interval = setInterval(() => {
      if (newPage && newPage.closed) {
        clearInterval(interval);
        handleModalClose();
      }
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Modal style={{ position: 'fixed', ...style }}>
      <div style={{ padding: '32px' }}>
        <Header>
          <HeaderTitle>
            {t('You are currently signed into multiple accounts.')}
          </HeaderTitle>
        </Header>
        <Content>
          {t(
            "You'll need to sign out of other accounts before using your primary account."
          )}
        </Content>
        <Footer>
          <Button
            text={t('Sign out of other account(s).')}
            onClick={async () => {
              await logoutUser({ redirect: false });
              if (windowHandler) {
                windowHandler.close();
              }
              handleModalClose();
            }}
          />
        </Footer>
      </div>
    </Modal>
  );
};
